import React, {FC} from 'react';
import {SvgIconComponent} from '@mui/icons-material';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import FmdGoodTwoToneIcon from '@mui/icons-material/FmdGoodTwoTone';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import InsightsIcon from '@mui/icons-material/Insights';
import RouterOutlinedIcon from '@mui/icons-material/RouterOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// track uses the same icons: src/main/webapp/images/icons/mainnav/nav-sprite.svg
const ICONS: Record<string, SvgIconComponent> = {
    map: FmdGoodIcon,
    mapV2: FmdGoodTwoToneIcon,
    voyage: AirportShuttleIcon,
    report: SummarizeOutlinedIcon,
    singleVoyage: NoCrashIcon,
    services: AssignmentIcon,
    reportV2: AssessmentTwoToneIcon,
    statistic: QueryStatsIcon,
    fuel: LocalGasStationIcon,
    drivers: GroupOutlinedIcon,
    equipment: RouterOutlinedIcon,
    accountInfo: SettingsOutlinedIcon,
    window: MonitorOutlinedIcon,
    system: DnsOutlinedIcon,
    cameras: CameraAltIcon,
    monitoringPlatform: InsightsIcon,
    help: HelpOutlineIcon,
    docs: SourceOutlinedIcon,
}

interface IProps {
    icon: string,
}

const NavigateIcon: FC<IProps> = ({icon}) => {
    const Icon = ICONS[icon]

    if (!Icon) {
        return <img src={icon} alt="" className="navigate-icon"/>
    }

    return <Icon className="navigate-icon"/>
};

export default NavigateIcon;
